import auth from "@/service/auth";

export default function logout() {
  if (auth.isAuthorized()) {
    auth.logout(false);
  } else {
    auth.deleteToken();
  }
}
